import { NavigateFunction } from 'react-router-dom';
import { PrimaryRoutes } from '../enums/internal-route-enums';
import { getFirstAvailableMainMenuRoute, isOnMainMenuRoute } from './main-menu-route-helper';

export const POWERBI_RESET_TO_DEFAULT_EVENT = 'powerbi-reset-to-default';

export function handleLogoHomeNavigation(
	permittedPages: string[],
	navigate: NavigateFunction,
	defaultPageId: string | null,
	onNavigateHome?: () => void
): void {
	const browserPathname = window.location.pathname;
	const browserSearch = window.location.search;
	const homeRoute = getFirstAvailableMainMenuRoute(permittedPages);

	if (isOnMainMenuRoute(browserPathname, homeRoute)) {
		const urlParams = new URLSearchParams(browserSearch);
		if (urlParams.has('page')) {
			const canonicalPath = homeRoute === PrimaryRoutes.Home ? PrimaryRoutes.Home : homeRoute;
			window.history.pushState({}, '', canonicalPath);
			window.dispatchEvent(
				new CustomEvent(POWERBI_RESET_TO_DEFAULT_EVENT, { detail: { pageId: defaultPageId } })
			);
		}
		onNavigateHome?.();
		return;
	}

	navigate(homeRoute);
	onNavigateHome?.();
}
